import type { Router } from 'vue-router';
import { createSsoGuard } from './sso';
import { createRouteGuard } from './route';
import { createProgressGuard } from './progress';
import { createDocumentTitleGuard } from './title';

/**
 * Router guard
 *
 * @param router - Router instance
 */
export function createRouterGuard(router: Router) {
  // SSO guard 必须最先注册，确保 ssoToken 写入本地后再执行路由鉴权
  createSsoGuard(router);
  createProgressGuard(router);
  createRouteGuard(router);
  createDocumentTitleGuard(router);
}
